/** global gtag */

import React     from 'react';
import PropTypes from 'prop-types';
import 'whatwg-fetch'
import VXPay     from './VXPay';
import 'whatwg-fetch'
import VXQL      from './VXQL';
import Helpers   from './Helpers';
//import json      from './data/lexyroxx-feed-curation-2018-09-04';

const AppContext = React.createContext();

let _vxqlEndpoint = 'https://www.visit-x.net/vxql';
let _vxqlWebToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwYXJ0bmVyVHlwZSI6ImNwIiwicGFydG5lcklkIjo4MTcwLCJyb2xlSWQiOjEwMDA1LCJjdXN0b21lckJhc2VJZCI6ODE3MH0.adaywvPtQAN9784Sy10MFgbXwa5oUPTM58Kk0v3lXKA';

let autoLoginHash;

// add language
_vxqlEndpoint += '?language=' + Helpers.getLanguage();

const LINKS = {
	PROFILE:         'https://www.visit-x.net/de/amateur/lexyroxx/',
	PHOTOS:          'https://www.visit-x.net/de/amateur/lexyroxx/fotos/',
	VIDEOS:          'https://www.visit-x.net/de/amateur/lexyroxx/videos/',
	DATA_PROTECTION: 'https://www.visit-x.net/de/datenschutz/',
	VRPORN:          'https://www.visit-x.net/de/magazin/vrporn/',
	MEDIATHEK:       'https://www.visit-x.net/de/tv/mediathek/lexy360/',
	BOUGHT_VIDEOS:   'https://www.visit-x.net/?jump=boughtvideos',
	BOUGHT_PHOTOS:   'https://www.visit-x.net/de/meinvisitx/fotos/gekaufte/',
};

export class AppProvider extends React.Component {
	constructor(props) {
		super(props);

		this.loadItems();
		this.initVXPay();

		this.state = {
			data:       [],
			isLoggedIn: false,
		};

		this.buyItem       = this.buyItem.bind(this);
		this.onLogoutClick = this.onLogoutClick.bind(this);
	}

	componentDidMount() {
		this.loadFeed(this.props.feedUrl);
	}

	initVXPay() {
		// check login state
		VXPay.isLoggedIn((isLoggedIn) => {
			if (isLoggedIn) {
				this.onAfterLogin();
			}
		});

		VXPay.onSuccess((result) => {
			const isPaymentSuccess = result && result.flow === 'moneycharge' && result.success;

			if (result && result.flow === 'login' && result.success) {
				this.onAfterLogin();

				if (result.userFromSignup) {
					window.gtag('event', 'sign_up', {
						'event_category': 'RoxxRacing',
						'event_label':    'signup',
					});
				}
			}

			if (typeof result.availableMoney !== 'undefined') {
				this.setBalance(result.availableMoney, isPaymentSuccess && this.onPaymentSuccessHandler ? this.onPaymentSuccessHandler : undefined);
			}
		});
	}

	onAfterLogin() {
		let vxql = VXQL(_vxqlEndpoint, _vxqlWebToken);
		vxql.query(
			`mutation ($transferToken: String!) {
						guest {
							session: createSession(vxpayToken: $transferToken) {
								token
								exp
								autoLoginHash
							}
						}
					}`,
			{
				transferToken: window.modalboxPaymentInstance.transferToken,
			}
		).then((data) => {
			if (data && data.guest && data.guest.session && data.guest.session.token) {
				_vxqlWebToken = data.guest.session.token;
				autoLoginHash = data.guest.session.autoLoginHash;

				vxql = VXQL(_vxqlEndpoint, _vxqlWebToken);
				vxql.query(
					`query {
								roxxRacing {
									boughtItems {
										id
										count
									}
								}
							}`,
					{}
				).then((data) => {
					if (data && data.roxxRacing && data.roxxRacing.boughtItems) {
						const boughtIds   = data.roxxRacing.boughtItems.map((item) => (item.id));
						const boughtItems = data.roxxRacing.boughtItems.reduce((acc, item) => {
							acc[item.id] = item.count;
							return acc;
						}, {});

						this.setState({
							buyInfo: {
								now: null,
								boughtItems,
								boughtIds,
							},
						});
					}
				});
			}
		});

		this.loadBalance();

		this.setState({
			isLoggedIn: true,
		});
	}

	onLogoutClick() {
		VXPay.logout((isLoggedIn) => {
			this.setState({
				isLoggedIn,
			});
		});
	}

	setBalance(balance, onUpdateState) {
		this.setState({
			balance: Math.floor(balance * 100),
		}, onUpdateState);
	}

	loadBalance() {
		VXPay.getBalance((result) => {
			this.setBalance(result.balance);
		});
	}

	loadItems() {
		// initial load
		let vxql = VXQL(_vxqlEndpoint, _vxqlWebToken);
		vxql.query(
			`query {
					  roxxRacing {
					    items {
					      id
					      label
					      price
					      priceFormatted
					      description
					      preview
					      albums {
					        id
					        title
					        link
					      }
					    }
					  }
					}`,
			{}
		).then((data) => {
			if (data && data.roxxRacing && data.roxxRacing.items) {
				this.setState({items: data.roxxRacing.items,});
			}
		});
	}

	loadFeed(feedUrl) {
		fetch(feedUrl)
			.then((response) => {
				return response.json();
			})
			.then((json) => {
				if (json.posts) {
					const arr = json.posts.map((item) => {
						const date = item.source_created_at.replace(/([0-9]+)-([0-9]+)-([0-9]+).*/, '$3.$2.$1');

						return {
							id:          item.id,
							date:        date,
							imgSrc:      item.image,
							imgSrcLarge: item.image,
							likes:       item.likes,
							title:       item.text.replace(/#/g, ' #').substring(0, 200) + '...',
							orientation: item.image_width > item.image_height * 1.05 ? 'landscape' : 'portrait',
							origin:      item.network_name.indexOf('Instagram') !== -1 ? 'Instagram' : 'Facebook',
							videoSrc:    item.video,
						};
					});

					this.setState({
						data: arr
					});
				}
			});
	}

	buyItem(itemIds) {
		const {isLoggedIn, balance} = this.state;

		if (isLoggedIn) {
			const ticketPrice = this.state.items.reduce((acc, item) => {
				acc += itemIds.indexOf(item.id) !== -1 ? item.price : 0;
				return acc;
			}, 0);

			if (balance < ticketPrice) {
				const options = {
					texts:             {
						TicketButtonOK: 'Tickets kaufen',
					},
					environment:       'vxonelp',
					allowNoPaymentFee: true,
					amounts:           [ticketPrice],
					onlyCustomAmounts: true,
				};

				VXPay.openPaytour(options);

				this.onPaymentSuccessHandler = () => {
					this.buyItem(itemIds);
					this.onPaymentSuccessHandler = undefined;
				};
			} else {
				let vxql = VXQL(_vxqlEndpoint, _vxqlWebToken);
				vxql.query(
					`mutation ($ids: [Int!]!) {
						roxxRacing {
							buyItems(ids: $ids) {
								id
								label
								count
							}
						}
					}`,
					{
						ids: itemIds,
					}
				).then((data) => {
					if (data && data.roxxRacing && data.roxxRacing.buyItems && data.roxxRacing.buyItems.length > 0) {
						const currBoughtIds = this.state.buyInfo && this.state.buyInfo.boughtIds ? this.state.buyInfo.boughtIds : [];
						const boughtIds     = data.roxxRacing.buyItems.map((item) => (item.id));
						const boughtCounts  = data.roxxRacing.buyItems.map((item) => (item.count));
						const boughtLabels  = data.roxxRacing.buyItems.map((item) => (item.label)).join(', ');

						const newBoughtIds = currBoughtIds.concat(boughtIds).filter((value, index, self) => {
							return self.indexOf(value) === index;
						});

						const boughtItems = boughtIds.reduce((acc, itemId, key) => {
							acc[itemId] = acc[itemId] ? acc[itemId] + boughtCounts[key] : boughtCounts[key];
							return acc;
						}, this.state.buyInfo && this.state.buyInfo.boughtItems ? this.state.buyInfo.boughtItems : []);

						this.setState({
							buyInfo: {
								now:       Date.now(),
								label:     boughtLabels,
								boughtIds: newBoughtIds,
								boughtItems,
							},
						}, () => {
							this.loadBalance();
						});

						window.gtag('event', 'buy_bundle', {
							'event_category': 'RoxxRacing',
							'event_label':    'bundles:' + boughtIds.sort().join(','),
							'value':          Math.round(100 * ticketPrice),
						});
					}
				});
			}
		} else {
			VXPay.openSignup();
		}
	}

	getLink(link) {
		return LINKS[link] ? (LINKS[link] + (autoLoginHash ? (LINKS[link].indexOf('?') === -1 ? '?' : '&') + 'uhash=' + autoLoginHash : '')) : '';
	}

	render() {
		return (
			<AppContext.Provider
				value={{
					balance:       this.state.balance,
					buyInfo:       this.state.buyInfo,
					buyItem:       this.buyItem,
					data:          this.state.data,
					isLoggedIn:    this.state.isLoggedIn,
					items:         this.state.items,
					getLink:       this.getLink,
					links:         LINKS,
					onLogoutClick: this.onLogoutClick,
					isMobile:      Helpers.isMobile(),
				}}
			>
				{this.props.children}
			</AppContext.Provider>
		);
	}
}

AppProvider.propTypes = {
	feedUrl: PropTypes.string,
};

export const AppConsumer = AppContext.Consumer;



// WEBPACK FOOTER //
// ./src/App.context.js